/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="fiveStarRatingSettings.module.ts" />
///<reference path="../../components/baseClasses/settingsPageController.ts"/>

module Meevo.Plugins.SelfCheckInKioskSettings {
    import IShortCutsService = Meevo.Components.ShortCuts.IShortCutsService;
    import SettingsPageController = Meevo.Components.BaseClasses.SettingsPageController;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import ISettingsPageController = Meevo.Components.BaseClasses.ISettingsPageController;
    import ISelectItem = Meevo.Model.ISelectItem;


    export class FiveStarRatingsSettingsController extends SettingsPageController<IFiveStarRatingSetting> implements ISettingsPageController<IFiveStarRatingSetting> {

        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.common.DataService',
            'meevo.components.common.IdentityService',
            'meevo.AppSettings',
            'meevo.components.busy.BusyService'
        ];

        protected get baseSecurityKey() {
            return SecurityKeys.BUSINESSINFO_FIVESTARRATINGSSETTINGS_TAB_MAIN;
        }


        public ratingPublishOptions: ISelectItem<number>[];
        public clientNameFormats: ISelectItem<FiveStarRatingsClientNameFormatEnum>[];

        get entityEndpoint() {
            return this.appSettings.API_ENDPOINTS.fiveStarRatingSettings;
        }

        get title() {
            return 'LABEL_FIVE_STAR_RATING_SETTINGS';
        }

        constructor(
            protected $scope: ng.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IStateService,
            protected shortCutsService: IShortCutsService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected appSettings: Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
        ) {
            super($scope, $rootScope, $state, shortCutsService, dataService, identityService, appSettings, busyService);

            this.ratingPublishOptions = [
                {
                    value: 0,
                    label: 'LABEL_NONE',
                },
                {
                    value: 5,
                    label: 'LABEL_5',
                },
                {
                    value: 4,
                    label: 'LABEL_4_AND_MORE',
                },
                {
                    value: 3,
                    label: 'LABEL_3_AND_MORE',
                },
                {
                    value: 2,
                    label: 'LABEL_2_AND_MORE',
                },
                {
                    value: 1,
                    label: 'LABEL_ALL',
                },
            ];

            this.clientNameFormats = [
                {
                    value: FiveStarRatingsClientNameFormatEnum.FirstNameLastInitial,
                    label: 'LABEL_FIRST_NAME_LAST_INITIAL',
                },
                {
                    value: FiveStarRatingsClientNameFormatEnum.FirstInitialLastInitial,
                    label: 'LABEL_FIRST_INITIAL_LAST_INITIAL',
                },
                {
                    value: FiveStarRatingsClientNameFormatEnum.FirstInitialLastName,
                    label: 'LABEL_FIRST_INITIAL_LAST_NAME',
                },
                {
                    value: FiveStarRatingsClientNameFormatEnum.FirstNameLastName,
                    label: 'LABEL_FIRST_NAME_LAST_NAME',
                },
                {
                    value: FiveStarRatingsClientNameFormatEnum.DoNotDisplay,
                    label: 'LABEL_FDO_NOT_DISPLAY',
                },
            ];
        }
    }

    angular.module('meevo.plugins.fiveStarRatingSettings')
        .controller('meevo.plugins.fiveStarRatingSettings.FiveStarRatingsSettingsController', FiveStarRatingsSettingsController);
}
